import { render, staticRenderFns } from "./SidePanelNewAssessment.vue?vue&type=template&id=71038372&scoped=true&"
import script from "./SidePanelNewAssessment.vue?vue&type=script&lang=js&"
export * from "./SidePanelNewAssessment.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelNewAssessment.vue?vue&type=style&index=0&id=71038372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71038372",
  null
  
)

export default component.exports